<template>
<v-container app :fluid="true" class="pt-0 pb-0">
    <v-row>
        <v-col cols="4" class="pt-0">            
            <v-text-field
                v-model="search"
                append-icon="fas fa-search"
                label="Buscar usuario"
                hide-details
                solo
                dense
                class="wost-text-input"
            ></v-text-field>                
        </v-col>
        <v-col cols="8" class="pt-0">
            <v-btn 
                @click="handleCreateUser" 
                rised 
                color="indigo" 
                dark
                class="float-right wost-btn-new" 
                v-if="verifyPermission('crear_usuarios')">
                <v-icon dark left size="12">fas fa-plus</v-icon>Nuevo usuario
            </v-btn>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12">
            <v-card>
                <v-data-table
                    class="wost-table"
                    :headers="headers"
                    :items="users"
                    item-key="name"
                    :search="search"
                    height="68vh"
                    fixed-header
                    v-if="verifyPermission('listar_usuarios')"
                >
                    <template v-slot:item.username="{item}">
                        {{ item.username | lowercase }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div class="datatable-cell-wrapper">
                            <a href="#" 
                                title="Editar" 
                                class="btn-actions btn-edit" 
                                @click="handleEditUser(item)"
                                v-if="verifyPermission('actualizar_usuarios')">
                                <v-icon color="amber" size="16">fas fa-pencil-alt</v-icon>
                            </a>
                            &nbsp;
                            <a v-if="item.status  === 'activo' && verifyPermission('inactivar_usuarios')" 
                                href="#" 
                                title="Inactivar" 
                                class="btn-actions btn-delete" 
                                @click="changeStatus(item, 'inactivar')">
                                <v-icon color="red darken-1" size="16">fas fa-minus-circle</v-icon>
                            </a>
                            <a v-else-if="item.status  === 'inactivo' && verifyPermission('activar_usuarios')" 
                                href="#" 
                                title="Activar" 
                                class="btn-actions btn-delete" 
                                @click="changeStatus(item, 'activar')">
                                <v-icon color="green darken-1" size="16">fas fa-check-circle</v-icon>
                            </a>
                        </div>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
    
    <v-navigation-drawer
        v-model="drawer"          
        width="500"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-text>
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    label="Nombres"
                                    hide-details
                                    v-model="formUser.first_name"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    label="Apellidos"
                                    hide-details
                                    v-model="formUser.last_name"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    label="Email"
                                    hide-details
                                    v-model="formUser.email"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    label="Nombre de usuario"
                                    hide-details
                                    v-model="formUser.username"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="actionCrud=='create'">
                            <v-col cols="12">
                                <v-text-field
                                    label="Contraseña"
                                    hide-details
                                    type="password"
                                    v-model="formUser.password"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-select label="Rol" :items="roles" v-model="formUser.role_id">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row v-if="actionCrud=='update'">
                            <v-col cols="12">
                                <v-switch
                                    v-model="formUser.change_password"
                                    label="Cambiar contraseña"
                                    hide-details
                                    class="mt-0"
                                    ></v-switch>
                            </v-col>
                        </v-row>
                        <v-row v-if="formUser.change_password">
                            <v-col cols="12">
                                <v-text-field
                                    label="Contraseña"
                                    hide-details
                                    type="password"
                                    v-model="formUser.password"
                                ></v-text-field>
                            </v-col>
                        </v-row>                        
                    </template>
                </v-card-text>
            </v-card>

            <div class="mt-3" style="text-align: right;">
                <v-btn @click="handleCancel">
                    Cancelar
                </v-btn>
                <v-btn class="ml-3" dark color="primary" v-if="actionCrud=='create'" @click="handleStoreUser">
                    Guardar
                </v-btn>
                <v-btn class="ml-3" dark color="primary" v-if="actionCrud=='update'" @click="handleUpdateUser">
                    Actualizar
                </v-btn>
            </div>
        </div>
    </v-navigation-drawer>
</v-container>
</template>

<script>
import ApiUsers from '../../apis/User'

export default {
    name: 'Users',
    data() {
        return {
            search: '',
            users: [],
            roles: [],
            headers: [
                { text: 'Nombres', value: 'first_name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Apellidos', value: 'last_name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Email', value: 'email', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Nombre de usuario', value: 'username', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 }
            ],
            titleForm: '',
            drawer: false,
            actionCrud: '',
            formUser: {
                user_id: null,
                first_name: null,
                last_name: null,
                email: null,
                username: null,
                password: null,
                role_id: null,
                change_password: false
            }
        }
    },
    methods: {
        clearData() {
            this.titleForm = ''
            this.actionCrud = ''
            this.formUser.user_id = null
            this.formUser.first_name = null
            this.formUser.last_name = null
            this.formUser.email = null
            this.formUser.username = null
            this.formUser.password = null
            this.formUser.role_id = null
            this.formUser.change_password = false
        },
        getAll() {
            ApiUsers.getAll().then((response) => {                
                this.users = response.data                
            }).catch( function(error){
                console.log('Ocurrió un error')
            });
        },
        getRoles() {
            ApiUsers.getRoles().then((response) => {                
                this.roles = response.data                
            }).catch( function(error){
                console.log('Ocurrió un error')
            });
        },
        showForm(title, actionCrud) {
            this.titleForm = title
            this.actionCrud = actionCrud
            this.drawer = !this.drawer
        },
        handleCreateUser(){
            this.showForm('Registrar Nuevo Usuario', 'create')
        },
        handleCancel(){
            this.drawer = false
        },
        handleStoreUser(){
            let validate = this.validate()
            if(validate.error) {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'REGISTRO DE USUARIO',
                    text: validate.message
                });
            } else {
                ApiUsers.create(this.formUser).then((response) => {
                    this.clearData()
                    this.getAll()
                    this.drawer = false
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'REGISTRO DE USUARIO',
                        text: 'El registro de usuario se realizó de manera exitosa!'
                    });
                }).catch( function(error){
                    console.log('Ocurrió un error')
                });
            }
            
        },
        handleEditUser(user){
            this.formUser.user_id = user.id
            this.formUser.first_name = user.first_name
            this.formUser.last_name = user.last_name
            this.formUser.email = user.email
            this.formUser.username = user.username
            this.formUser.password = null
            this.formUser.role_id = user.roles[0].id
            this.formUser.change_password = false
            this.showForm('Modificar Datos de Usuario', 'update')
        },
        handleUpdateUser() {
            let validate = this.validate()
            if(validate.error) {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'REGISTRO DE USUARIO',
                    text: validate.message
                });
            } else {
                ApiUsers.update(this.formUser).then((response) => {
                    this.clearData()
                    this.getAll()
                    this.drawer = false
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'ACTUALIZACIÓN DE USUARIO',
                        text: 'La actualización de usuario se realizó de manera exitosa!'
                    });
                }).catch( function(error){
                    console.log('Ocurrió un error')
                });
            }
        },
        changeStatus(user, status){
            this.$swal({
                    title: "¿Desea confirmar?",
                    text: "Confirma que desea " + status + " el usuario",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Confirmar",
                    cancelButtonText: "Cancelar",
                }).then((result) => {
                    if(result.value){
                        if(result.value === true){
                            ApiUsers.changeStatus(user.id).then((response) => {
                                this.clearData()
                                this.getAll()
                                this.drawer = false
                            }).catch( function(error){
                                console.log('Ocurrió un error')
                            });
                        }
                    }                    
                })
        },
        validate() {
            let error =false
            let message = ''
            if(this.formUser.first_name == null || this.formUser.first_name == '') {
                error = true,
                message = 'Debe ingresar el nombre.'
            }
            if(this.formUser.last_name == null || this.formUser.last_name == '') {
                error = true,
                message = 'Debe ingresar el apellido.'
            }
            if(this.formUser.email == null || this.formUser.email == '') {
                error = true,
                message = 'Debe ingresar el email.'
            }
            if(this.formUser.username == null || this.formUser.username == '') {
                error = true,
                message = 'Debe ingresar el nombre de usuario.'
            }
            if(this.actionCrud == 'create') {
                if(this.formUser.password == null || this.formUser.password == '') {
                    error = true,
                    message = 'Debe ingresar la contraseña.'
                }
            }
            if(this.actionCrud == 'update') {
                if(this.formUser.change_password) {
                    if(this.formUser.password == null || this.formUser.password == '') {
                        error = true,
                        message = 'Debe ingresar la contraseña.'
                    }
                }
            }            
            if(this.formUser.role_id == null || this.formUser.role_id == '') {
                error = true,
                message = 'Debe seleccionar el rol del usuario.'
            }

            return {
                error: error,
                message: message
            }
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted() {
        this.getAll()
        this.getRoles()
    }
}
</script>

<style>

</style>